"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTooltip = void 0;
var dom_1 = require("@floating-ui/dom");
var react_1 = __importStar(require("react"));
var Chart_1 = require("./Chart");
function buildVirtualElement(chart, div) {
    var maxSpot = chart.highLightSpots.reduce(function (c, i) {
        if (!c)
            return i;
        if (c.item.y > i.item.y)
            return c;
        return i;
    });
    var minSpot = chart.highLightSpots.reduce(function (c, i) {
        if (!c)
            return i;
        if (c.item.y < i.item.y)
            return c;
        return i;
    });
    var height = Math.abs(chart.yNormalizer.normalize(maxSpot.item.y) - chart.yNormalizer.normalize(minSpot.item.y)) + 40;
    var rect = div.getBoundingClientRect();
    var clientX = rect.left + chart.xNormalizer.normalize(maxSpot.item.x) - 5 - div.scrollLeft;
    var clientY = rect.top + chart.yNormalizer.normalize(maxSpot.item.y) - 20;
    var virtualEl = {
        getBoundingClientRect: function () {
            return {
                width: 10,
                height: height,
                x: clientX,
                y: clientY,
                top: clientY,
                left: clientX,
                right: clientX + 10,
                bottom: clientY + height,
            };
        }
    };
    return virtualEl;
}
function ChartTooltip(_a) {
    var content = _a.content, reference = _a.reference;
    var chart = (0, react_1.useContext)(Chart_1.ChartContext);
    var toolTipRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!reference || !toolTipRef.current || !chart.highLightSpots)
            return;
        toolTipRef.current.style.display = "inline-block";
        (0, dom_1.computePosition)(buildVirtualElement(chart, reference.current), toolTipRef.current, {
            strategy: chart.tooltipContainer ? "fixed" : "absolute",
            placement: "top",
            middleware: [(0, dom_1.flip)(), (0, dom_1.shift)({ limiter: (0, dom_1.limitShift)({ offset: 10 }), padding: 30 })]
        }).then(function (_a) {
            var x = _a.x, y = _a.y;
            if (toolTipRef.current == null)
                return;
            Object.assign(toolTipRef.current.style, {
                left: "".concat(x, "px"),
                top: "".concat(y, "px"),
                opacity: 1,
                visibility: 'visible'
            });
        });
    }, [chart.highLightSpots && chart.highLightSpots.length && chart.highLightSpots[0].item.x, toolTipRef.current]);
    if (!reference.current)
        return null;
    if (!content)
        return null;
    return react_1.default.createElement("span", { ref: toolTipRef, className: 'chart-tooltip', style: { opacity: 0, visibility: "hidden", display: "none" } }, content);
}
exports.ChartTooltip = ChartTooltip;
//# sourceMappingURL=ChartTooltip.js.map